module.exports = __webpack_public_path__ + "static/media/img1-3.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img1-3.png
// module id = 1699
// module chunks = 3